import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

const inputVariants = cva(
  `flex h-10 w-full rounded-md border px-3 py-2 text-sm shadow-sm file:border-0 
  file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed 
  disabled:opacity-50 focus:outline-none ring-offset-background text-black`,
  {
    variants: {
      variant: {
        default: "border-input bg-white text-black focus:border-white focus:text-black",
        red: "border-rollops-secondary bg-white text-black focus:border-rollops-primary focus:text-black",
      }
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={`${inputVariants({ variant, className })} text-black placeholder:text-gray-500`}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input } 